<template>
    <div  class="mcontent">
        <layout type="L_R"
           v-if="root.device!='phone'"
             :class="[root.device=='ipad'&&'mipad']"
        >           
                 <layout flex='2'  type="T_B">      
                  <layout type="L_R" flex='1'>
                    <!-- <wrapper style="margin-top: -0.6vw;">
                        <cusbox txt="首单批次准交率">                            
                              <char1 v-if="getDeliveryRateOfTheFirstBatchShow" :data="char1_data" :datelist="datelist" />                                                  
                              <dv-loading v-else>Loading...</dv-loading>
                        </cusbox>
                    </wrapper>                      -->
                    <layout flex='1' type="T_B">
                                 <!-- <wrapper flex='1' type=''>                                   
                                      <imenu @change="change" />                                   
                                 </wrapper> -->
                                <wrapper flex='5' style="z-index:0;">
                                    <cusbox v-if="getIntermediateModuleShow" :showtxt='false'>
                                          <mc v-if="JSON.stringify(mdata)!='{}'" :data='mdata'/>                                      
                                    </cusbox>
                                    <dv-loading v-else>Loading...</dv-loading>
                                 </wrapper>
                           </layout>  
                  </layout>
                  <layout type="L_R"  flex='1.5'>
                      <wrapper>
                          <cusbox  txt="大货生产数据分析">
                               <itemlist 
                                    :count='9'
                                    :columns='columns1'
                                    :data='data1'    
                                    v-if="getCurrentBusinessDataShow"                
                                />
                                <dv-loading v-else>Loading...</dv-loading>
                          </cusbox>
                      </wrapper>
                  </layout>
                 </layout>
                <layout flex='1' type="L_R">
                     <wrapper  style="margin-top: -0.6vw;">
                          <cusbox  txt="成衣未准交款">
                               <itemlist 
                                    :count='15'
                                    :columns='columns2'
                                    :data='data2'   
                                    v-if="getPaymentNotAllowedForReadyToWearShow"                 
                                >
                                 <template  slot='img' slot-scope="{data}">                          
                            <img class="icon"  :src='data.pic'>                         
                      </template>
                               </itemlist>
                               <dv-loading v-else>Loading...</dv-loading>
                          </cusbox>
                    </wrapper>
                </layout>
        </layout>
         <mobile class="device_phone ppd notransform" v-else>
           <div class="moblieline h250">
               <layout type="T_B" style="height:100%">
                <imenu class="cusim" @change="change" style="flex: none;"/>        
               <cusbox flex=1 v-if="getIntermediateModuleShow" :showtxt='false'>
                      <mc  :data='mdata'/>                                      
                 </cusbox>
                 <dv-loading v-else>Loading...</dv-loading>
               </layout>
               

           </div>
           <!-- <div class="moblieline">
                 <cusbox txt="首单批次准交率">                            
                              <char1 v-if="getDeliveryRateOfTheFirstBatchShow" :data="char1_data" :datelist="datelist" />                                                  
                              <dv-loading v-else>Loading...</dv-loading>
                        </cusbox>
           </div> -->
             <div class="moblieline h450">
<cusbox  txt="大货生产数据分析">
                               <itemlist 
                                    :count='9'
                                    :columns='cols_1'
                                    v-if="getCurrentBusinessDataShow"      
                                    :data='data1'                    
                                />
                                <dv-loading v-else>Loading...</dv-loading>
                          </cusbox>
             </div>
              <div class="moblieline h650">
   <cusbox  txt="成衣未准交款">
                               <itemlist 
                                    :count='15'
                                    :columns='cols_2'
                                    :data='data2'     
                                    v-if="getPaymentNotAllowedForReadyToWearShow"                   
                                >
                                 <template  slot='img' slot-scope="{data}">                          
                            <img class="icon"  :src='data.pic'>                         
                      </template>
                               </itemlist>
                               <dv-loading v-else>Loading...</dv-loading>
                          </cusbox>
              </div>
              
           
         </mobile>
   </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue"
import wrapper from "@/components/cuscom/wrapper.vue"
import cusbox from "@/components/vip/cusbox"
import imenu from "../common/other/imenu.vue"
import itemlist from "@/components/cuscom/itemlist"
import {char1} from "./report/index"
import {mc} from "./other/index"
import {cols_1,cols_2} from "./device/phone_column.js"
export default {
    components:{
        layout,
        wrapper,
        cusbox,
        imenu,
        itemlist,
        char1,
        mc 
    },
     inject:['root'],
    data(){
        return {
            cols_1,
            cols_2,
            columns1:[
                {
                    title:"货号",
                    key:'orderId',                   
                    align:"center",                   
                    width:'8vw',                   
                },
                {
                    title:"批次",
                    key:'batch'    
                },
                {
                    title:"计划件数",
                    key:'orderNum',
                    align:"center",        
                } , 
                {
                    title:"入库",
                    key:'comeNum',
                    align:"center",        
                }, 
                {
                    title:"在产",
                    key:'inProductionNum',
                    align:"center",        
                }, 
                {
                    title:"货期",
                    key:'requireDate',
                    align:"center",        
                }, 
                {
                    title:"状态",
                    key:'state',
                    align:"center",        
                }, 
                {
                    title:"上市日期",
                    key:'sheetdate',
                    align:"center",        
                }, 
                {
                    title:"销量",
                    key:'quantity',
                    align:"center",        
                }, 
                {
                    title:"销售额",
                    key:'money',
                    align:"center",        
                }, 
                {
                    title:"大仓库存",
                    key:'warehouseQty',
                    align:"center",        
                }, 
                {
                    title:"店铺库存",
                    key:'storeQty',
                    align:"center",        
                }  
            ],
             columns2:[
                {
                    title:"制单号",
                    key:'goodsNo',                   
                    align:"center",                   
                    width:'6vw',                   
                },
                 {
                    title:"批次",
                    key:'batch',
                     width:'3.5vw',
                      align:"center",     
                },               
               {
                    title:"下单量",
                    key:'orderNum',
                     align:"center",     
                },                 
                {
                    title:"入库量",
                    key:'comeNum',
                     align:"center",     
                },                 
                {
                    title:"准交量",
                    key:'onTimeNum',
                     align:"center",     
                } 
            ],
            data1:[],
            getCurrentBusinessDataShow:false,
            data2:[],
            getPaymentNotAllowedForReadyToWearShow:false,
            api:this.$apis['supply'],
            char1_data:{},
            getDeliveryRateOfTheFirstBatchShow:false,
            datelist:[],
            mdata:{} ,
            getIntermediateModuleShow:false        
        }
    },
     mounted(){ 
        this.getdata()
    },
    created(){
        this.change()
    },

  methods:{
      change(obj){ 
          this.getIntermediateModuleShow = false      
          this.api.getIntermediateModule(obj).then(res=>{
              
              this.getIntermediateModuleShow = true
              let that = this
              setTimeout(function(){   
                            
          
                   res.data?that.mdata=res.data:that.mdata={
                    comeNum: 0,
                    comeStyleNum: 0,
                    deptId: null,
                    errorRate: 0,
                    inProductionNum: 0,
                    inProductionStyleNum: 0,
                    onTimeRate: 0,
                    orderNum: 0,
                    season: null,
                    styleNum: 0,
                    time: null,
                    year: null
                   }                   
              },0)
          
          })
      },
      
      getdata(){
          this.api.getCurrentBusinessData().then(res=>{    
            this.getCurrentBusinessDataShow = true
            let that = this
            setTimeout(function(){
                that.data1=res.data.list;
            },0)           
            
        })
         this.api.getPaymentNotAllowedForReadyToWear().then(res=>{  
             this.getPaymentNotAllowedForReadyToWearShow = true
             let that = this
             setTimeout(function(){
                 that.data2=res.data.list;  
             },0)
                      
        })
        this.api.getDeliveryRateOfTheFirstBatch().then(res=>{  
            var obj={batch:[],rates:[]}
            for(var i=0;i<res.data.list.length;i++){
                obj.batch.push(res.data.list[i].batch);
                obj.rates.push(res.data.list[i].crossRate);
            }
            this.getDeliveryRateOfTheFirstBatchShow = true
            let that = this
            setTimeout(function(){
                that.datelist=obj.batch;
                that.char1_data=obj;
            },0)
                        
        })
      }
  }
}
</script>
<style lang="scss" scoped>
@import './device/phone.scss';
.notransform{
 .cusim{
     margin-bottom:25px;
 }
}
.mcontent{
    color: #fff;
     height: 100%;
     display: flex;
}
</style>